exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Favourites_favIcon__Fkd9k .icon-star-filled{color:#e8aa00}", ""]);

// Exports
exports.locals = {
	"favIcon": "Favourites_favIcon__Fkd9k"
};